import { Box } from "@mui/material";
import Text from "@ds/components/Text";
import type { TComponentUVP } from "../../type";

const ContainerUVP: React.FC<{ uvp: TComponentUVP[] }> = (props) => {
  const { uvp } = props;
  return (
    <Box
      display="flex"
      gap={uvp.length < 4 ? 5 : 0}
      textAlign="center"
      alignItems="flex-start"
      justifyContent={uvp.length < 4 ? "center" : "space-between"}
      flexDirection="row"
    >
      {uvp?.map((item: TComponentUVP, idx: number) => (
        <Box
          key={idx}
          display="flex"
          flexDirection="column"
          textAlign="center"
          alignItems="center"
          width={270}
          flexWrap="wrap"
          gap={1}
        >
          <Box component="img" src={item.uvpImage.mediaPath} width="120px" height="120px" />
          <Text weight="600" variant="h2">
            {item.uvpTitle}
          </Text>
          <Text weight="600" color="inactive-secondary">
            {item.uvpDescription}
          </Text>
        </Box>
      ))}
    </Box>
  );
};

export default ContainerUVP;
